export default {
  heading: {
    id: 'checkout_bouygues_magic_link_layout_used_error_heading',
    defaultMessage: 'Il n’y a plus rien à faire !',
  },
  firstParagraph: {
    id: 'checkout_bouygues_magic_link_layout_used_error_first_paragraph',
    defaultMessage:
      'Vous avez déjà confirmé l’achat de votre téléphone via ce lien.',
  },
  secondParagraph: {
    id: 'checkout_bouygues_magic_link_layout_used_error_second_paragraph',
    defaultMessage:
      'Consultez votre {profileLink, html} ou vos emails pour suivre votre commande.',
  },
  profileLink: {
    id: 'checkout_bouygues_magic_link_layout_used_error_profile_link',
    defaultMessage: 'compte client Back Market',
  },
}
